import { usePostAlerts } from './usePostAlerts';

export const useUnreadAlertsCount = () => {
  const { data } = usePostAlerts({
    count_only: true,
    read: false,
  });
  return data?.pages[0]?.count ?? 0;
};
